import React from 'react';
import {Glob as G} from "../libs/Glob.mjs";
import AdminGroup from "./AdminGroup.mjs";
import { Accordion, Button,	Form, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import GroupIcon from "../media/images/GroupIcon.mjs";
import "./AdminGroupsList.css";
import AdminUsersList from "./AdminUsersList.mjs";
import TextLabel from "../controls/TextLabel.mjs";
import CdIcon from "../media/images/CdIcon.mjs";

const prefix = 'AdminGroupsList';

const AdminGroupsList = class extends AdminUsersList {
	constructor(props) {
		super(props);
		this.state.group = G.getPageParam('group') || '';
		this.uid = G.generateUid(prefix);
	}
	componentDidMount() {
		G.register( this.props.dataKey, l => { this.setState({ data: l })}, this.uid);
		G.register('currentPage', po => {
			const g = po?.params?.group || '';
			if ( g !== this.state.group ) this.setState({ group: g });
		});
		if ( ! this.state.group ) G.setCurrentPageParam('group','admin');
	}
	render() {
		if ( ! this.state.data ) return <p><TextLabel value={"Loading…"}/></p>;
		return(
			<>
				<div className={prefix} id={this.uid}>
					<div className={"mb-2 text-end"}>
						<Button
							color="primary"
							className="btn-icon"
							onClick={() => {
								this.toggleModal('newGroup', {canEditItems:true, id:''})
							}}
						>
							<i>
								<GroupIcon />
							</i>
							<b>
								<TextLabel value={"New group"} />
							</b>
						</Button>
					</div>
					<Accordion
						toggle={ (x) => {
							G.setCurrentPageParam('group', x === this.state.group ? '' : x);
						}}
						open={ this.state.group }
					>
						{ this.state.data.groups.map(g => (
							<AdminGroup
								key={ g.id }
								group={ g }
								change={ this.makeChange }
								users={ this.state.data.users }
								editGroup={ (gid) => {
									const gdata = G.clone(this.state.data.groups.find(g => g.id === gid));
									this.toggleModal('editGroup', gdata );
								} }
							/>
						))}
					</Accordion>
				</div>
				<Modal
					className={prefix+' newGroup'}
					isOpen={ this.state.editing === 'newGroup'}
					toggle={this.toggleModal}
					onOpened={ this.ModalAutoFocus }
				>
					<Form
						onSubmit={ e => {
							e.preventDefault();
							if (! this.state.onEdit.id ) return;
							if ( Object.keys( this.state.editError).length ) return;
							this.makeChange('addGroup');
							G.setCurrentPageParam('group', this.state.onEdit.id );
						}}
					>
						<ModalHeader toggle={this.toggleModal}>
							<GroupIcon />
							<TextLabel value={"New group"} />
						</ModalHeader>
						<ModalBody>
							<ListGroup>
								<ListGroupItem>
									{ this.textInput('id', G.label('GroupIdMandatory'),(v)=>{
										if ( ! v.length ) return G.label('Group ID is mandatory');
										if ( v.length < 3 ) return G.label('GroupIdMinLen',{len:3});
										if ( v.match(/[^a-zA-Z0-9]/) ) return G.label('Only alphanumeric charaters allowed');
										if ( this.state.data.groups.find( g => (g.id === v)) ) return G.label('Group already exists');
										return false;
									}) }
									{ this.textInput('name', G.label('GroupDescOptional')) }
								</ListGroupItem>
								<ListGroupItem>
									<div className={"mb-1"}>
										<TextLabel value={"Items"} />
									</div>
									{ this.booleanInput('canCreateItem', G.label('Items can be created')) }
									{ this.booleanInput('canEditItems', G.label('Items can be changed')) }
									{ this.textInput( 'dataset', G.label('Dataset ID')) }
								</ListGroupItem>
								<ListGroupItem>
									<div>
										<TextLabel value={"Form"} />
									</div>

								</ListGroupItem>
							</ListGroup>
						</ModalBody>
						<ModalFooter>
							<Button
								className={"btn-icon"}
								type="submit"
								color="success"
								disabled={ !! Object.keys( this.state.editError).length }
							>
								<i>
									<CdIcon />
								</i>
								<b>
									<TextLabel value={"Add"} />
								</b>
							</Button>
						</ModalFooter>
					</Form>
				</Modal>
				<Modal
					className={prefix+' editGroup'}
					isOpen={ this.state.editing === 'editGroup'}
					toggle={this.toggleModal}
					onOpened={ this.ModalAutoFocus }
				>
					<Form
						onSubmit={ e => {
							e.preventDefault();
							if (! this.state.onEdit.id ) return;
							if ( Object.keys( this.state.editError).length ) return;
							this.makeChange('editGroup');
							G.setCurrentPageParam('group', this.state.onEdit.id );
						}}
					>
						<ModalHeader toggle={this.toggleModal}>
							<GroupIcon />
							<TextLabel value={"Edit group"} />
						</ModalHeader>
						<ModalBody>
							<ListGroup>
								<ListGroupItem>
									{ this.textInput('id', G.label('GroupIdMandatory'), 'disabled') }
									{ this.textInput('name', G.label('GroupDescOptional')) }
								</ListGroupItem>
								<ListGroupItem>
									<div className={"mb-1"}>
										<TextLabel value={"Items"} />
									</div>
									{ this.booleanInput('canCreateItem', G.label('Items can be created')) }
									{ this.booleanInput('canEditItems', G.label('Items can be changed')) }
									{ this.textInput( 'dataset', G.label('Dataset ID')) }
								</ListGroupItem>
								<ListGroupItem>
									<div className={"mb-1"}>
										<TextLabel value={"Data upload target"}/>
									</div>
									{this.textInput('uploadURL', G.label('Upload URL'))}
									{this.textInput('uploadXHeader', G.label('Upload X-header'))}
								</ListGroupItem>
							</ListGroup>
						</ModalBody>
						<ModalFooter>
							<Button
								className={"btn-icon"}
								type="submit"
								color="success"
								disabled={!!Object.keys(this.state.editError).length}
							>
								<i>
									<CdIcon />
								</i>
								<b>
									<TextLabel value={"Save"}/>
								</b>
							</Button>
						</ModalFooter>
					</Form>
				</Modal>
			</>
		)
	}
}

export default AdminGroupsList;